module.exports = __webpack_public_path__ + "4f63993475e9a1ac6dc92c40da0ef933.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/misc/sample-activities.png
// module id = 1681
// module chunks = 0